<template>
  <div class="wap-cont">
    <div class="wap-header">
      <div class="logo">
        <img src="@/assets/logo.png" @click="navClick()" alt="">
      </div>
      <div class="nav">
        <i class="el-icon-menu" @click="nav.show = true"></i>
      </div>
    </div>
    <el-drawer size="300px"
      :visible.sync="nav.show"
      direction="rtl" >
      <div class="nav-cont">
        <div class="nav-user">
          <div class="img">
            <img src="@/assets/user.jpeg" alt="头像" >
          </div>
          <div class="btn" @click="signOut">退出系统</div>
        </div>
        <el-menu 
        :default-active="active"
        class="nav-menu" 
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b" >
          <template v-for="item in menu.tree" :index="item.id">
            <el-menu-item v-if="! item.son || item.son.length == 0" :key="item.id" :index="item.url" @click="navClick(item)">
              <i v-if="item.icon" :class="item.icon"></i>
              <template slot="title"><span slot="title">{{item.name}}</span></template>
            </el-menu-item>
            <el-submenu v-if="item.son && item.son.length > 0" :key="item.id" :index="item.url">
              <template slot="title"><i v-if="item.icon" :class="item.icon"></i> <span slot="title">{{item.name}}</span></template>
              <template v-for="obj in item.son">
                <el-menu-item v-if="! obj.son || obj.son.length == 0" :key="obj.id" :index="obj.url" @click="navClick(obj)">{{obj.name}}</el-menu-item>
                <el-submenu  v-if="obj.son && obj.son.length > 0" :key="obj.id" :index="obj.id">
                  <span slot="title"><i class="el-icon-menu"></i> <span slot="title">{{obj.name}}</span></span>
                  <el-menu-item v-for="(data, jndex) in obj.son" :key="jndex" :index="data.url" @click="navClick(data)">{{data.name}}</el-menu-item>
                </el-submenu>
              </template>
            </el-submenu>
          </template>
        </el-menu>
      </div>
    </el-drawer>

    <slot></slot>

  </div>
</template>

<script>
export default {
  name: 'Login',
  created () {
    
  },
  data () {
    return {
      nav: {
        show: false,
      },
      menu: {
        list: this.$init.menu, 
        tree: this.$init.getMenuTree(), // 菜单树
      },
      active: '/report', // 选中标签
    }
  },
  methods: {
    signOut () {
      sessionStorage.clear();
      this.$init.token = {};
      this.$init.user = {};
      this.$init.role = {};
      // TODO 没权限认证封印
      // this.$init.menu = [];
      this.$cookies.remove('token');
      this.$router.push('/login');
    },
    navClick (obj = {id: '0', name: '首页'}) {
      this.$store.commit('addTab', obj)
      this.nav.show = false
    },
  },
  computed: {
    // 标签
    tabs () {
      return this.$store.state.tabs;
    },
    // 标签列表
    tabsList () {
      return this.$store.state.tabs.list;
    },
    // 当前标签
    tabsNow () {
      return this.$store.state.tabs.now;
    }
  },
  watch: {
    tabsNow (val) { 
      if(val != '0'){
        var url = '';
        var obj = {};
        this.tabsList.forEach((e, i) => {
          if (e.id == val) {
            url = e.url;
            obj = e;
          }
        })
        this.$router.push({
          path: url,
          query: obj.query ? obj.query : {}
        })
      }else{
        this.$router.push('/home')
      }
    },
    '$route.path' (str) {
      this.active = str
    },
  }
}
</script>

<style lang="scss" scoped>
.wap-cont{
  box-sizing: border-box;
  padding-top: 52px;
  height: 100%;
  overflow-y: auto;
}
.wap-header{
  position: fixed;
  z-index: 1000;
  height: 52px;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  display: flex;
  background-color: $color-theme1;
  .logo{
    flex: 10;
    img{
      display: block;
      height: 50px;
    }
  }
  .nav{
    font-size: 30px;
    line-height: 50px;
    color: #fff;
  }
}

.nav-cont{
  padding: 2px;
  .nav-user{
    display: flex;
    align-items: center;
    padding: 10px;
    color: #eaeaea;
    .img{
      margin-right: 10px;
      img{
        display: block;
        height: 50px;
        border-radius: 50px;
      }
    }
    .btn{
      font-size: 16px;
    }
  }
}
</style>


<style lang="scss">
// 移动端
.wap-cont{
	.el-drawer{
		background-color: #545c64;
	}
  .el-menu{
    border: none;
  }
}
</style>